import gql from 'graphql-tag';

import cardElementConfigurationDetails from './cardElementConfigurationDetails';
import cardTemplateDetails from './cardTemplateDetails';
import cardAddressesDetails from './cardAddressesDetails';
import accountCardPrintProductConfiguration from './accountCardPrintProductConfiguration';
import { albumCustomPrintDetails } from '../../../../graphql/fragments/album-custom-print';

const accountCardDetails = gql`
  fragment accountCardDetails on AccountCard {
    id
    type
    created_at
    updated_at
    status
    type
    account {
      id
    }
    card {
      id
      card_categories {
        records {
          id
          name
          is_active
        }
      }
      card_side_groups(slice: { limit: 9999 }) {
        total
        records {
          id
          side
          name
          asset_image {
            id
            url
          }
          card_sides(slice: { limit: 99 }) {
            total
            records {
              id
              name
              asset_image {
                id
                url
              }
              card_template {
                ...cardTemplateDetails
              }
            }
          }
        }
      }
    }
    account_card_sides {
      id
      side
      card_side {
        id
        card_template {
          ...cardTemplateDetails
        }
        card_element_configurations {
          ...cardElementConfigurationDetails
        }
      }
      card_element_configurations {
        ...cardElementConfigurationDetails
      }
    }
    ...cardAddressesDetails
    ...accountCardPrintProductConfiguration
    album_custom_print {
      ...albumCustomPrintDetails
    }
    purchased_custom_print_account_card {
      pcm_order_status
      pcm_order_status_updated_at
    }
  }
  ${cardTemplateDetails}
  ${cardElementConfigurationDetails}
  ${cardAddressesDetails}
  ${accountCardPrintProductConfiguration}
  ${albumCustomPrintDetails}
`;

export default accountCardDetails;
